import { render } from "./doc.vue?vue&type=template&id=53d04233&ts=true"
import script from "./doc.vue?vue&type=script&lang=ts"
export * from "./doc.vue?vue&type=script&lang=ts"

import "./doc.vue?vue&type=style&index=0&id=53d04233&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__